import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { TransferirContratoModel } from 'model/api/gestao/contrato/transferir-contrato-model';

export function usePutTransferirContrato() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putTransferirContrato = useCallback(
        (contrato: TransferirContratoModel) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/contrato/${contrato.contratoId}/transferir`,
                method: 'PUT',
                data: contrato,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putTransferirContrato,
    };
}
